import { render, staticRenderFns } from "./UnitMemberApplication.vue?vue&type=template&id=2096f79a&scoped=true&"
import script from "./UnitMemberApplication.vue?vue&type=script&lang=js&"
export * from "./UnitMemberApplication.vue?vue&type=script&lang=js&"
import style0 from "./UnitMemberApplication.vue?vue&type=style&index=0&id=2096f79a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096f79a",
  null
  
)

export default component.exports